import React, { useEffect, useState } from "react";
import { backIncstance, formatDateString, getLoginInfo } from "../utils/commonFunctions";
import Pagination from "react-js-pagination";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Warning from "./Warning";
import styled from "styled-components";
import {QRCodeSVG} from 'qrcode.react';

// svgs
const URLS = {
  CREATE_URL: process.env.REACT_APP_TUTOR_SHARE_LINK,
  GET_URL: process.env.REACT_APP_TUTOR_SHARE_LIST,
  REFERER_URL: process.env.REACT_APP_REFERER_URL
}
const INFORM_TEXT = `공유 링크 생성하기를 누르면 새로운 공유 URL이 생성됩니다.\n 이전 대화 목록에 대한 링크는 상단의 사용자 이름을 클릭 후, 공유 목록을 확인해주세요.`
const CreateUrl = props => {
  const { onClose, target, id } = props;
  const [uuid, setUuid] = useState(null)

  const loginInfo = getLoginInfo();

  const [loading, setLoading] = useState(false)
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(
      () => {
        handleCopy();
      },
    ).catch((err) => {
      setWarnSetting(prev => ({
        ...prev,
        warningTxt: '다시 시도해주세요.'
      }))
    });
  };

  const touchAPI = async (method, url, data) => {

    if (!loginInfo.id) {
      return
    }
    setLoading(true)

    const response = await backIncstance(method, url, data)
    try {
      if (response.status === 200 || response.status === 201) {
        const resData = await response?.json();
        return resData;
      } else {
        setWarnSetting(prev => ({
          ...prev,
          warningTxt: '다시 시도해주세요.'
        }))
      }
    } catch (err) {
      console.log(err)
      setWarnSetting(prev => ({
        ...prev,
        warningTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`
      }))
    } finally {
      setLoading(false)
    }
  }

  const requestUrl = async () => {
    const reqData = {
      [target]: id
    }
    if (uuid) {
      copyToClipboard(`${URLS.REFERER_URL}/share/${uuid}`);
      return;
    }
    const resData = await touchAPI('POST', URLS.CREATE_URL, reqData)
    if (resData && resData.uuid) {
      setUuid(resData.uuid)
    }
  }

  useEffect(() => {
    if (uuid) {
      copyToClipboard(`${URLS.REFERER_URL}/share/${uuid}`);
    }
  }, [uuid])


  /**
* warning Handler
*/
  const clearWarnState = () => {
    setWarnSetting({
      ...warnSetting,
      warningTxt: '',
    })
    setIsWarning(false)
  }
  const [isWarning, setIsWarning] = useState(false);
  const [warnSetting, setWarnSetting] = useState({
    warningTxt: '',
    onClose: () => clearWarnState(),
  })
  useEffect(() => {
    if (warnSetting.warningTxt !== '') {
      setIsWarning(true)
    }
  }, [warnSetting.warningTxt])


  const handleCopy = () => {
    if (!uuid) return
    setWarnSetting({
      ...warnSetting,
      warningTxt: '주소가 복사되었습니다.',
    })
  }


  return (
    <Style>
      <div className="modal">
        <div className="modal-content" style={{ width: '500px', minHeight: '200px' }}>
          <div className="alert__top">URL 공유하기</div>
          <div className="alert__middle">
            <p className="inform-text">{INFORM_TEXT}</p>
            <div className="share-link">
              <CopyToClipboard text={uuid ? `${URLS.REFERER_URL}/share/${uuid}` : null} onCopy={handleCopy}>
                <p>{ uuid ? `${URLS.REFERER_URL}/share/${uuid}` : `버튼을 눌러 URL을 공유해 보세요.`}</p>
              </CopyToClipboard>
              <button onClick={requestUrl}>
                {loading ?
                  '생성 중...' :
                   (
                     uuid ?
                       'URL 복사하기' :
                       'URL 생성하기')}
              </button>
            </div>
            <div className="share-qr">
              {uuid && <QRCodeSVG value={`${URLS.REFERER_URL}/share/${uuid}`}/>}
              {!uuid && <p>'URL 생성하기'를 누르면 QR코드가 만들어져요.</p>}
            </div>
          </div>
          <div className="alert__bottom">
            <button onClick={onClose} className="crs-btn positive-btn">닫기</button>
          </div>
        </div>
      </div>
      {
        isWarning &&
        <Warning settings={warnSetting} />
      }
    </Style>
  )
}

export default CreateUrl;

const Style = styled.div`
.alert__top {
  padding: 10px 0
}
.alert__middle {
.inform-text {
line-height : 24px;
}
.share-link{

display: flex;
    padding: 5px 10px;
    border: 1px solid rgba(0,0,0,.15);
    border-radius: 13px;
    margin: 10px 0;
    p {
    line-height: 39px;
    margin-right: 10px;
    flex: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    }
    button {
        border: none;
    border-radius: 13px;
    padding: 10px;
    cursor: pointer;
}
    }
}
}


`
